import { DialogM } from "@common/components/alert/dialog/Dialog"
import moment from "moment"

export function showLiveNotTodayDialog(liveDate) {
    DialogM.show({
        champion: "zoe",
        variant: "main",
        text1: "Le live n'est accessible que le jour-même",
        text2: `Reviens ${moment(liveDate).format("dddd")} pour te connecter !`,
        exitButton: true,
        onPressBack: () => {},
    })
}
